<template>
  <div v-if="team" class="container-fluid content mt-3 mt-md-0">
    <sakali-header title="Kader">
      <template v-slot:super-title>{{team.name}}</template>
      <template v-slot:icon>
        <team-emblem :emblem-id="team.emblemId"
                     size="57"/>
      </template>
    </sakali-header>
    <!-- Liste der Spiele -->
    <squad :team="team"></squad>
  </div>
</template>

<script>
import Squad from "../components/transfer/Squad";
import sakaliApi from "../sakali-api";

export default {
  data() {
    return {
      team: null
    }
  },
  methods: {
    loadTeam() {
      sakaliApi.get('/teams/' + this.$route.params.teamId).then(response => {
        this.team = response.data;
      }).catch(error => {
        this.handleErrorAction(error)
      })
    }
  },
  created() {
    this.loadTeam();
  },
  components: {
    Squad
  }
}
</script>

<style scoped>
</style>
